import { render, staticRenderFns } from "./setInvite.vue?vue&type=template&id=fa8c6156&"
import script from "./setInvite.vue?vue&type=script&lang=ts&"
export * from "./setInvite.vue?vue&type=script&lang=ts&"
import style0 from "./setInvite.vue?vue&type=style&index=0&id=fa8c6156&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports